export const errorlist = {
	'verify_otp': {
		'invalidotp' : 'Please enter valid 4 digit otp.',
	},
	'login': {
		'invalidemail' : 'Please enter a valid email-Id.',
		'invalidpassword' : 'Please enter password.',
		'passwordminlength' : 'password must be atleast 6 character long.',
		'recordnotfound':'Email is not registered.',
		'invalidcredentials':'Mobile number & password is not match.',
	},
	'contact': {
		'name' : 'Please enter name.',
		'email' : 'Please enter a valid email-id.',
		'phone' : 'Please enter phone number.',
		'invalidlength':'Phone length minimum 10.',
		'area':'Please choose an area.',
		'message':'Please enter your message.',
	},
	'signup':{
		'invalidfirstname': 'Please enter your First Name.',
		'invalidlastname': 'Please enter your Last Name.',
		'invalidemail': 'Please enter your Email.',
		'invalidemailformate': 'Please enter your valid Email.',
		'invalidarea': 'Please choose your area.',
		'invalidpassword': 'Please enter your password.',
		'invalidcnfpassword': 'Password does not match.',
		'invalidpasswordlength': 'Password minimum length shoule be 6.',
		'passwordminlengthshort': 'Password length shoule be 6.',
		'invalidterm': 'Please Accept term & condition.',
		'invalidcross': 'Please enter Cross Street.',
		'invalidphone': 'Please enter your Phone.',
		'invalidphonelength':'Enter minimum 10 number.',
		'invalidstreet': 'Please enter Street Address.',
		'invalidapt': 'Please enter Apt Address.',
		'invalidoldpassword':'Please enter your old password.'
	},
	'forgot_password':{
		'invalidmobile' : 'Please enter mobile number.',
		'mobileminlength' : 'Mobile Number must be atleast 5 digit long.',
	},
	'placeOrder':{
		'day1' : 'Choose first pickup day.',
		'time1' : 'Choose first pickup time.',
		'day2' : 'Choose first delivery day.',
		'time2':'Choose first delivery time.',
		'day3' : 'Choose second pickup day.',
		'time3' : 'Choose second pickup time.',
		'day4' : 'Choose second delivery day.',
		'time4':'Choose second delivery time.',
		'message':'Please enter message.',
		'whitener':'Please choose a whitener.',
		'softner':'Please choose a softner.',
		'detergent':'Please choose a detergent.',
		'pay_type':'Please choose a Pay Type.',
		'resendotpsuccess' : 'You will receive a verification code in your mobile/mail.',
		'invalidcardtype':'Please choose your card type.',
		'invalidcardnumber':'Please enter your card number.',
		'invalidmonth':'Please choose card exp. month.',
		'invalidyear':'Please choose card exp. year.',
		'invalidcsv':'Please enter cvv.',
		'invalidcardnumberlength':'Please enter valid card number.',
		'is_laundry':'Please select either laundry or dry cleaning service.'
		
		
	},
	'appointment':{
		'invalidservice' : 'Please choose one service type.',
		'invalidreason' : 'Please enter your reason to schedule this appoinment.',
		'chooseslot' : 'Please choose one slot',
		'invalidremark' : 'Please enter your remark to reschedule this appointment.',
	},
	'cancel_appointment':{
		'invalidreson' : 'Please enter your reason for cancel this appoinment.',
		'invalidrejectreson' : 'Please enter your reason for reject this appoinment.',
		'cancelsuccess': 'Your appointment Successfully canceled.',
		'rejectsuccess': 'You reject this appointment Successfully.',
	},
	'add-money':{
		'invalidMoney':'Please Enter Amount'
    },
    'medical_record': {
        'invaliddoctorname': 'Please enter doctor name', 
        'invaliddisease': 'Please enter disease name', 
        'invalidhospital': 'Please enter hospital name',
        'invaliddate': 'Please enter date name', 
    }

}


// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/providers/errorlist.ts